/**
 * First-order exponential low-pass (IIR) filter.
 * y[n] = alpha * x[n] + (1 - alpha) * y[n-1]
 */
export default class LowPassFilter {
  constructor(alpha) {
    this.alpha = alpha;
    this.previous = null;
  }

  filter(sample) {
    if (this.previous == null) {
      this.previous = sample;
      return sample;
    }

    const filtered = this.alpha * sample + (1 - this.alpha) * this.previous;
    this.previous = filtered;
    return filtered;
  }
}
